/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const reminderRecipeTableHead = [
  {
    headerName: 'Actions',
    field: 'action',
    cellRenderer: 'ActionCellRender',
    maxWidth: Styles.Width_100,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-overflow-visible',
    editable: false,
    sortable: false,
    showCheckboxIcon: false,
    hideFilterIcon: true,
    filter: false,
    resizable: true,
    suppressMenu: false,
  },
  {
    headerName: 'Rebate Program/ Check Payee',
    field: 'reminderShortDescr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_171,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'rpcCellRenderer',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reminder Type',
    field: 'reminderTypeCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'reminderName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    columnSpan: 3,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'DescriptionCellRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Template Type',
    field: 'templateName',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'User',
    field: 'respUserId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_350,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'RespUserIdCellRender',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    showDropDownVal: true,
    dropDownValueCol: 'respUserName',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];
export default reminderRecipeTableHead;
